<mat-form-field class="mat-block" [ngClass]="{'l-updated-field': isOverriden}">
  <mat-select id="ddShortTime" [formControl]="ctrlShortTime" [placeholder]="placeholder" required>
    <mat-option *ngFor="let shortTime of shortTimeList" [value]="shortTime">
      {{shortTime.format}}
    </mat-option>
  </mat-select>
  <mat-error
    id="errShortTime"
    class="error-message"
    *ngIf="ctrlShortTime.dirty ||ctrlShortTime.touched"
  >
    {{ "organization.create.section_3.short_time_required" | translate }}
  </mat-error>
</mat-form-field>
